import React from "react";
import { useNavigate } from "react-router-dom";
import { Mic, BookOpen, ArrowRight, Clock } from "lucide-react";

/**
 * InterviewTestDrivePanel — collapsible right-side panel showing the user's
 * past interview playbooks + quick links to playbook builder + mock interview.
 *
 * Renders inside the dashboard's right column, alongside the Personalized
 * Insights and Resume Makeover panels. Mounted in a Collapsible by Landing.jsx.
 */
export default function InterviewTestDrivePanel({ recentPlaybooks, makeover }) {
  const navigate = useNavigate();
  const playbooks = recentPlaybooks || [];
  const analysisId = makeover?.analysis_id;
  return (
    <div className="space-y-3" data-testid="interview-panel">
      <div className="text-[13px]" style={{ color: "#475569" }}>
        Build a tailored playbook or run a live mock — both pre-loaded with
        the Job Description from your latest tailor.
      </div>

      <div className="grid grid-cols-2 gap-2">
        <button
          type="button"
          onClick={() => navigate(analysisId ? `/playbooks?analysis_id=${analysisId}` : "/playbooks")}
          className="flex flex-col items-center justify-center gap-1 py-3 text-[12px] font-semibold"
          style={{
            background: "white",
            color: "#0F1B2D",
            border: "1px solid #0F1B2D",
            borderRadius: 8,
          }}
          data-testid="interview-panel-playbook"
        >
          <BookOpen size={16} className="rm-text-orange" />
          <span>Interview playbook</span>
        </button>
        <button
          type="button"
          onClick={() => navigate(analysisId ? `/mock-interview?analysis_id=${analysisId}` : "/mock-interview")}
          className="flex flex-col items-center justify-center gap-1 py-3 text-[12px] font-semibold"
          style={{
            background: "linear-gradient(135deg, #3B82F6 0%, #1E40AF 100%)",
            color: "#0F1B2D",
            border: "1px solid #0F1B2D",
            borderRadius: 8,
            fontWeight: 700,
          }}
          data-testid="interview-panel-mock"
        >
          <Mic size={16} />
          <span>Mock interview</span>
        </button>
      </div>

      {/* Recent playbooks list */}
      {playbooks.length > 0 && (
        <div>
          <div className="font-mono-rm text-[10px] uppercase tracking-widest mb-1.5"
               style={{ color: "#475569", fontWeight: 700 }}>
            Your recent playbooks
          </div>
          <ul className="space-y-1">
            {playbooks.map((p) => (
              <li key={p.id}>
                <button
                  type="button"
                  onClick={() => navigate(`/playbooks/${p.id}`)}
                  className="w-full flex items-center gap-2 px-2 py-1.5 text-left text-[12px] rounded"
                  style={{ background: "#F8FAFC", border: "1px solid #E2E8F0" }}
                  data-testid={`interview-panel-playbook-${p.id}`}
                >
                  <Clock size={11} className="opacity-50 flex-shrink-0" />
                  <span className="flex-1 min-w-0 truncate">
                    <strong>{p.job_title || "Playbook"}</strong>
                    {p.company_name && (
                      <span style={{ color: "#475569" }}> · {p.company_name}</span>
                    )}
                  </span>
                  <ArrowRight size={10} className="opacity-50" />
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
